import React from 'react';
import { brandConfig as DNBrandConfig } from '../branding/driveNinja';
import PropTypes from 'prop-types';

const BrandContext = React.createContext(DNBrandConfig);

export { BrandContext };

export const BrandProvider = ({ children, brandConfig }) => {
  return (
    <BrandContext.Provider value={brandConfig}>{children}</BrandContext.Provider>
  );
};

BrandProvider.propTypes={
  children: PropTypes.node,
  brandConfig: PropTypes.object,
};

export default BrandProvider;
